<template>
  <div>
    <v-layout wrap justify-center mt-12>
      <v-flex xs11 sm9>
        <h1>Admin</h1>

        <v-layout row wrap>
          <v-flex xs12>
            <admin-create-company/>
          </v-flex>
          <v-flex xs12>
            <admin-create-stripe-plan/>
          </v-flex>
        </v-layout>

        <v-tabs v-model="activeTab" background-color="primary" grow class="mt-6">
          <v-tab href="#listUsers" class="white--text">
            <v-icon left small color="white">mdi-account</v-icon>
            Utilisateurs
          </v-tab>

          <v-tab href="#listCompanies" class="white--text">
            <v-icon left small color="white">mdi-office-building</v-icon>
            Entreprises
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="activeTab" class="background">
          
          <v-tab-item value="listUsers">
            <v-layout wrap>
              <v-flex xs12 v-if="isLoadingUsers">
                <v-progress-linear indeterminate class="mt-6"/>
              </v-flex>
              <v-flex xs12 v-else>
                <admin-list-users :allUsers="allUsers" @getMoreUserDetails="getMoreUserDetails"/>
              </v-flex>
            </v-layout>
          </v-tab-item>

          <v-tab-item value="listCompanies">
            <v-layout wrap>
              <v-flex xs12 v-if="isLoadingCompanies">
                <v-progress-linear indeterminate class="mt-6"/>
              </v-flex>
              <v-flex xs12 v-else-if="allCompanies.length > 0">
                <admin-list-companies :allCompanies="allCompanies"/>
              </v-flex>
            </v-layout>
          </v-tab-item>

        </v-tabs-items>

      </v-flex>
    </v-layout>

  </div>
</template>

<script>
import AdminListUsers from '@/components/admin/AdminListUsers.vue'
import AdminListCompanies from '@/components/admin/AdminListCompanies.vue'
import AdminCreateCompany from '@/components/admin/AdminCreateCompany.vue'
import AdminCreateStripePlan from '@/components/admin/AdminCreateStripePlan.vue'

export default {
  components: {
    AdminListUsers,
    AdminListCompanies,
    AdminCreateCompany,
    AdminCreateStripePlan
  },
  data: () => ({
    allUsers: [],
    isLoadingUsers: false,
    allCompanies: [],
    isLoadingCompanies: false,
    activeTab: "listUsers",
    isShowingCreateCompanyDialog: false
  }),
  mounted() {
    this.getAllUsers()
    this.getAllCompanies()
    if (this.$route.query.activeTab === 'listCompanies') this.activeTab = 'listCompanies'
    if (this.$route.query.activeTab === 'listUsers') this.activeTab = 'listUsers'
  },
  methods: {
    async getAllUsers() {
      this.isLoadingUsers = true
      this.allUsers = (await this.$functions.httpsCallable('listUsers')()).data.sort((a, b) => {
        const domainOfA = a.email.split('@')[1]
        const domainOfB = b.email.split('@')[1]
        if (domainOfA === domainOfB) return a.email > b.email ? 1 : -1
        else return domainOfA > domainOfB ? 1 : -1
      })
      this.isLoadingUsers = false
    },
    async getAllCompanies() {
      this.isLoadingCompanies = true
      this.allCompanies = (await this.$functions.httpsCallable('listCompanies')()).data.sort((a, b) => a.name > b.name ? 1 : -1)
      this.isLoadingCompanies = false
    },
    async getMoreUserDetails(data) {
      const userId = data.userId;
      const { user } = (await this.$functions.httpsCallable('getMoreUserDetails')({
        userId
      })).data
      this.allUsers = this.allUsers.map(u => {
        if (u.id === userId) {
          u.dossiersNbCreated = user.dossiersNbCreated
        }
        return u
      })
    }
  },
}
</script>